<template>
  <div class="signuppage">
    <section class="hero">
      <div class="login-container">

        <div class="login-container-columns">
          <div class="login-container-column">
            <h2>köhler. klinker app</h2>
            <p>Legen Sie nun ihren kostenfreien Account an und profitieren Sie vom gesamten Funktionsumfang der köhler Klinker App.</p>
          </div>
        </div>
        <form class="form" @submit.prevent="handleSubmit">
        <div class="login-container-columns">
          <div class="login-container-column">
             <input type="text" name="firstname" v-model="firstname" placeholder="Ihr Vorname" :class="{ 'is-invalid': submitted && !firstname }">
             <div v-show="submitted && !firstname" class="invalid-feedback">Bitte Ihre Vornamen eingeben</div>
          </div>
          <div class="login-container-column">
             <input type="text" name="lastname" v-model="lastname" placeholder="Ihr Nachname" :class="{ 'is-invalid': submitted && !lastname }">
             <div v-show="submitted && !lastname" class="invalid-feedback">Bitte Ihre Nachnamen eingeben</div>
          </div>
        </div>
<!--
        <div class="login-container-columns">
          <div class="login-container-column">
             <input type="text" name="company" v-model="company" placeholder="Firma (optional)" >
          </div>
        </div>
-->
        <div class="login-container-columns">
          <div class="login-container-column">
             <input type="email" name="email" v-model="email" placeholder="E-Mail" :class="{ 'is-invalid': submitted && !email }">
             <div v-show="submitted && !email" class="invalid-feedback">Bitte eine E-Mail-Adresse angeben</div>
          </div>
          <div class="login-container-column">
             <input type="password" name="password" v-model="password" placeholder="Passwort" :class="{ 'is-invalid': submitted && !password }">
             <div v-show="submitted && !password" class="invalid-feedback">Bitte Passwort eingeben</div>
          </div>
        </div>
        <div class="login-container-columns">
          <div class="login-container-column">
            <p>Ich erlaube köhler die Speicherung meiner Daten im Rahmen der DSVGO. <a href="#!">Unsere Datenschutzerklärung lesen</a></p>
          </div>
        </div>
        <div class="login-container-columns">
          <div class="login-container-column">
             <p>
             <button v-show="!loggingIn" type="submit" :disabled="loggingIn">Account anlegen</button>
             <img v-show="loggingIn" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            </p>
          </div>
        
       </div>
       </form>

      </div>
    
    </section>

  </div>
</template>
<script>


export default {
    data () {
        return {
            firstname: '',
            lastname: '',
            company: '',
            email: '',
            password: '',
            submitted: false,
        }
    },
    watch:{
    },
    computed: {
        loggingIn () {
            return this.$store.state.authentication.status.loggingIn;
        },
        originalRoute(){
          return this.$router.originalRoute
        }
    },
    created () {
        // reset login status
        this.$store.dispatch('authentication/logout');
        //console.log( this.$router.originalRoute );
    },
    methods: {
            
        signinCompleted(e){
          console.log( 'Login via Social Service');
        },
      
        scrtnxtsctn() {
          $('html,body').animate({ scrollTop: $('#home_content').position().top },800);
        },

        handleSubmit (e) {
            //this.submitted = true;
            const to = 'ThankyouPage' //this.originalRoute //"/"; //this.$route.params.r ? "/"+this.$route.params.r : "/"
            const { firstname, lastname, company, email, password } = this;
            const { dispatch } = this.$store;
            if (email && password && firstname && lastname) {
                dispatch('authentication/signup', { firstname, lastname, company, email, password, to });
            }
        }
    }
};
</script>
<style scoped>
  .signuppage { }

  section.hero { display: flex; align-items: center; justify-content: center; min-height: 100vh; padding: 6.4999999em 0 4em; background: transparent center 10% no-repeat; background-size: 95%;  position: relative;
    border: 0px solid #e30613 }

 .login-container { max-width: 40em; padding-bottom: 3em; background: rgba(0,0,0,0.4); padding: 0 0.9333em; border-radius: 3px;  transform:translateY(0em); }
 .login-container-columns { padding: 0 0.93333em; }
 .login-container-column { padding: 0.233333em 0.433333em; border: 0 solid yellow; }

 .login-container-columns:last-child { padding: 0 0.93333em 0.93333em; } 
 
 
  @media screen and ( min-width: 768px) {
  section.hero { padding: 8.7999999em 0 4em;}    
    .login-container-columns { display: flex; align-items: flex-start; }
    section.hero { background-size: 55%; }
  }

  .error { border: 1px solid #dc1200; padding: 0.6333333em; margin: 0 0 0.9333333em 0; background: rgba(245, 17, 17, 0.12) }
  .close { text-decoration: none; color: #dc1200; font-size: bold;}

  img { display: block; max-width: 100%; }
  .login-container img { max-width: 10em; margin: 0 auto 0.9333333em; }
  input { border: 1px solid #343434; border-radius: 3px; padding: 0.4333333em 0.9333333em; margin-bottom: 0.33333em; outline: 0; transition: border-color 0.2s; font-size: 1.2rem; }
  input:focus { border-color: #000; }


  .fixedonbottom { position: absolute; bottom: 1em; left: 50%; transform:translateX(-50%); text-align: center;  }
  .fixedonbottom h3 { font-weight: 300; padding: 0; margin: 0; }
  .icon.icon-chevron-down { display: block; width: 3rem; height: 3rem; background: url(/img/icons-red/chevron-down.svg) center center no-repeat; background-size: contain; margin: 0 auto; }
  .pointer { cursor:pointer;}

  #home_content { min-height: 100vh; padding: 0 0 5em;  }
  #home_content article { padding: 2.733333em 0; }
  article h1 { color: #00853e; font-size: 2.83333rem; border: 0 solid red; margin: 0; }
  article h2 { color: #00853e; font-size: 2.8333333em; }
  article h1 + h2 { padding: 0; margin: 0; }



</style>
